import React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

const noticeSx = {
	position: 'fixed',
	margin: '0 auto',
	left: 0,
	right: 0,
	bottom: 0,
	backgroundColor: '#222',
	color: 'white'
};

function Copyright() {
	return (
		<Typography
			variant="body2"
			color="textSecondary"
			align="center"
			sx={noticeSx}>
			{'Copyright © '}
			<Link color="inherit" href="https://cyberdev.us/">
				CyberDev
			</Link>{' '}
			{new Date().getFullYear()}
			{'.'}
		</Typography>
	);
}

export default Copyright;
